import { cn } from "@/shared/lib/utils";
import * as React from "react";

import HouseSearchIcon from "@/assets/icons/house/houseSearchWhite.svg?react";
import { useDispatch } from "react-redux";
import { updateSearchText } from "../model/slice";
import { useAppSelector } from "@/app/store/hooks";
import { selectSearchText } from "../model/selectors";

export interface ISearchProps {
    className?: string;
}

export function Search({ className }: ISearchProps) {

    const [searchText, setSearchText] = React.useState<string>('');
    const reduxSearchText = useAppSelector(selectSearchText);

    const dispatch = useDispatch();

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        dispatch(updateSearchText(searchText));
    }

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value);
    };

    React.useEffect(() => {
        setSearchText(reduxSearchText);
    }, [reduxSearchText]);

    return (
        <form
            className={cn(
                'flex gap-1 bg-white h-[42px] shadow-bg rounded-[10px] overflow-hidden',
                className,
            )}
            onSubmit={handleSubmit}
        >
            <input 
                className="flex-1 font-manrope px-[20px] font-medium text-[12px] md:text-[16px] text-blue-70 outline-none"
                placeholder="Введите адрес, район или почтовый индекс…"
                value={searchText}
                onChange={handleSearchChange}
            />
            
            <button
                className={cn(
                    "bg-blue hover:bg-blue-90 rounded-[10px] min-w-[61px] h-full flex justify-center items-center",
                )}
            >
                <HouseSearchIcon className="w-[21px] h-[18px]"/>
            </button>
        </form>
    );
}
